/**
 * Echo Site Animation Controller
 *
 * Handles GSAP-powered hero content animations for the Echo site
 */

(function() {
  'use strict';

  if (typeof gsap === 'undefined') {
    setBodyNoAnimation()
    return;
  }

  /**
   * Which selectors to target for hero animations
   *
   * To prevent animations 'jumping' (from end position, to start when this JS loads), there is CSS added to these
   * selectors to set the element's start state.
   * See `sass/patterns/home-hero.scss`
   */
  const CONFIG = {
    heroSelectors: [
      '.home-hero-pattern',
      '.parent-page-hero-pattern',
      '.landing-page-hero-pattern'
    ],
    heroChildSelectors: 'h1, h2, h3, .hero-subtitle, .hero-content, .btn, p'
  };

  function setBodyNoAnimation() {
    document.querySelector('body').classList.add('no-animation')
  }

  /**
   * Initialize hero content animations
   */
  function initHeroAnimations() {
    // Respect user's motion preferences
    if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
      setBodyNoAnimation()
      return;
    }

    CONFIG.heroSelectors.forEach(selector => {
      const heroes = document.querySelectorAll(selector);

      heroes.forEach((hero) => {
        if (hero.dataset.echoHeroAnimated === 'true') return;

        const children = hero.querySelectorAll(CONFIG.heroChildSelectors);

        if (children.length === 0) return;

        // Filter to only direct meaningful children (avoid duplicates)
        const uniqueChildren = Array.from(children).filter((child, index, arr) => {
          return !arr.some((other, otherIndex) =>
            otherIndex < index && other.contains(child)
          );
        });

        gsap.set(uniqueChildren, { opacity: 0, y: 20 });

        gsap.to(uniqueChildren, {
          opacity: 1,
          y: 0,
          duration: 0.6,
          stagger: 0.12,
          ease: 'power2.out',
          delay: 0.15,
          onComplete: () => {
            hero.dataset.echoHeroAnimated = 'true';
          }
        });
      });
    });
  }

  // Initialize when DOM is ready
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initHeroAnimations);
  } else {
    initHeroAnimations();
  }

})();
